<template>
  <div>
    <span v-if="data.column.field === 'active'">
      <div class="d-flex justify-content-between text-align-left">
        <span>
          <i
            v-if="data.formattedRow.active"
            class="chart-dot-green mr-50"
          />
          <i
            v-else
            class="chart-dot-red mr-50"
          />
          {{ capitalizeFirstLetter(data.formattedRow.active.toString()) }}
        </span>
        <b-button
          v-b-modal.modal-create-edit-section-group
          variant="link"
          class="p-0"
          @click="editSectionGroupModel(data.row)"
        >
          <GjIcon
            name="Edit"
            class="text-primary"
          />
        </b-button>
      </div>
    </span>
    <span v-else-if="data.column.field === 'name'">
      <b-button
        variant="link"
        :to="`/admin/info/sectiongroup/${data.row.id}`"
        size="sm"
      >
        {{ data.formattedRow.name }}
      </b-button>
    </span>

    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'

export default {
  components: {
    GjIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const editSectionGroupModel = sectionGroup => store.commit('SET_SECTION_GROUP_MODEL', sectionGroup)
    const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1)
    return { editSectionGroupModel, capitalizeFirstLetter }
  },
}
</script>
